import { updateObject } from '../utility';

const initialState = {
  userFeedbackList: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_USER_FEEDBACK_LIST': {
      return updateObject(state, {
        userFeedbackList: action.payload,
      });
    }
    default:
      return state;
  }
};

export default reducer;
